import * as React from 'react';

import {
  createStyles,
  Grid,
  Theme,
  WithStyles,
  withStyles
} from '@material-ui/core';

import { ILieuucationPropertiesSafety } from '@lieuu/core';

import BarChart from '../charts/BarChart';
// import Calendar from '../charts/Calendar';
// import LineDailyChart from '../charts/LineDailyChart';
import Statistic from '../charts/Statistic';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      [theme.breakpoints.up('lg')]: {
        paddingLeft: theme.spacing(6),
        paddingRight: theme.spacing(6)
      }
    },
    grid: { width: '100%' },
    divider: {
      height: '100%'
    }
  });

type IProps = WithStyles<typeof styles> & {
  properties: ILieuucationPropertiesSafety;
  cbsaProperties: ILieuucationPropertiesSafety;
};

const Safety: React.FC<IProps> = ({ classes, properties, cbsaProperties }) => {
  return (
    <div className={classes.root}>
      <Grid
        alignItems="center"
        justify="center"
        spacing={2}
        className={classes.grid}
        container
      >
        {/* <LineDailyChart
          title="Crimes in Past Month"
          data={properties.crimes.nonViolent.crimes}
          cbsaData={cbsaProperties.crimes.nonViolent.crimes}
          description={
            <>
              <b>
                {
                  'This is the count of violent and nonviolent crimes in December 2018 in this neighborhood.'
                }
              </b>
              <br />

              {' A violent crime includes assaults, robberies, or shootings.'}
              {
                ' A nonviolent crime includes arrests, arsons, burglaries, thefts, vandalism, or other crimes.'
              }
              <br />
              <i>
                {
                  ' We are constantly adding to our crime data. Stay tuned for further developments!'
                }
              </i>
            </>
          }
        /> */}
        {(properties.crimes.violent.totalCount > 0 ||
          properties.crimes.nonViolent.totalCount > 0) && (
          <BarChart
            title="Crimes in Past Month"
            variant="number"
            data={[
              {
                id: 'Violent',
                lieuucation: properties.crimes.violent.totalCount,
                cbsa: cbsaProperties.crimes.violent.totalCount
              },
              {
                id: 'Nonviolent',
                lieuucation: properties.crimes.nonViolent.totalCount,
                cbsa: cbsaProperties.crimes.nonViolent.totalCount
              }
            ]}
            description={
              <>
                <b>
                  {
                    'This is the count of violent and nonviolent crimes in December 2018 in this neighborhood.'
                  }
                </b>
                <br />

                {' A violent crime includes assaults, robberies, or shootings.'}
                {
                  ' A nonviolent crime includes arrests, arsons, burglaries, thefts, vandalism, or other crimes.'
                }
                <br />
                <i>
                  {
                    ' We are constantly adding to our crime data. Stay tuned for further developments!'
                  }
                </i>
              </>
            }
          />
        )}
        {properties.crimes.violent.totalCount === 0 && (
          <Statistic
            title="Violent Crimes in Past Month"
            value={'None'}
            cbsaValue={cbsaProperties.crimes.violent.totalCount}
            description={
              <>
                <b>
                  {
                    'This is the count of violent crimes in December 2018 in this neighborhood.'
                  }
                </b>
                {' A violent crime includes assaults, robberies, or shootings.'}
                <br />
                <i>
                  {
                    ' We are constantly adding to our crime data. Stay tuned for further developments!'
                  }
                </i>
              </>
            }
          />
        )}
        {properties.crimes.nonViolent.totalCount === 0 && (
          <Statistic
            title="Nonviolent Crimes in Past Month"
            value={'None'}
            cbsaValue={cbsaProperties.crimes.nonViolent.totalCount}
            description={
              <>
                <b>
                  {
                    'This is the count of non-violent crimes in December 2018 in this neighborhood.'
                  }
                </b>
                {
                  ' A nonviolent crime includes arrests, arsons, burglaries, thefts, vandalism, or other crimes.'
                }
                <br />
                <i>
                  {
                    ' We are constantly adding to our crime data. Stay tuned for further developments!'
                  }
                </i>
              </>
            }
          />
        )}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Safety);
